// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const JsonIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="JsonIcon" ref={forwardedRef} {...props}>
      <path d="M6.466 2.811C5.288 3.424 4.889 4.217 4.889 5.982V7.46c0 1.37-.617 2.289-1.704 2.541 1.087.252 1.704 1.171 1.704 2.54v1.478c0 1.765.399 2.558 1.577 3.17L6.176 18c-1.849-.324-2.882-1.748-2.918-3.982L3.24 12.883C3.204 11.045 2.424 10.72 1.5 10.72V9.28c.924 0 1.704-.325 1.74-2.163l.018-1.135C3.294 3.748 4.328 2.324 6.176 2z" />
      <path d="M13.825 2c1.848.324 2.881 1.748 2.917 3.982l.018 1.135c.036 1.838.816 2.163 1.74 2.163v1.44c-.924 0-1.704.325-1.74 2.163l-.018 1.135c-.036 2.234-1.069 3.657-2.917 3.982l-.29-.811c1.178-.613 1.576-1.406 1.576-3.171V12.54c0-1.37.617-2.289 1.704-2.541-1.087-.252-1.704-1.171-1.704-2.54V5.981c0-1.765-.398-2.558-1.576-3.17z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const JsonIcon = /* @__PURE__ */ Object.assign(JsonIconComponent, {
  displayName: 'JsonIcon',
});
